/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { boolean } from 'purify-ts/Codec';
import { UIPrefsStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var WhitespacePreset;
(function (WhitespacePreset) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespacePreset.PREF_NAME = 'whitespace_preset';
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespacePreset.DEFAULT_VALUE = true;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespacePreset.load = () => UIPrefsStore.loadUIPreference({ preference: WhitespacePreset.PREF_NAME });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespacePreset.set = (value) => UIPrefsStore.patchUIPreference({
        preference: WhitespacePreset.PREF_NAME,
        value,
    });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespacePreset.get = () => {
        const pref = UIPrefsStore.getUIPref()(WhitespacePreset.PREF_NAME, boolean);
        const status = pref.status;
        switch (status) {
            case 'not-loaded':
            case 'not-present':
                return WhitespacePreset.DEFAULT_VALUE;
            case 'not-valid':
                return WhitespacePreset.DEFAULT_VALUE;
            case 'valid':
                return pref.value;
            default:
                throw utils.AssertionError.assertNever(status);
        }
    };
})(WhitespacePreset || (WhitespacePreset = {}));
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var WhitespaceForFile;
(function (WhitespaceForFile) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespaceForFile.getPrefName = (fileId) => `whitespace-${fileId}`;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespaceForFile.load = (fileId) => UIPrefsStore.loadUIPreference({ preference: WhitespaceForFile.getPrefName(fileId) });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespaceForFile.set = (fileId, value) => UIPrefsStore.patchUIPreference({
        preference: WhitespaceForFile.getPrefName(fileId),
        value,
    });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    WhitespaceForFile.get = (fileId) => {
        const pref = UIPrefsStore.getUIPref()(WhitespaceForFile.getPrefName(fileId), boolean);
        const status = pref.status;
        switch (status) {
            case 'not-loaded':
            case 'not-present':
                return WhitespacePreset.get();
            case 'not-valid':
                return WhitespacePreset.get();
            case 'valid':
                return pref.value;
            default:
                throw utils.AssertionError.assertNever(status);
        }
    };
})(WhitespaceForFile || (WhitespaceForFile = {}));
